import React, { useContext } from "react";
import { ContentContext } from "../contexts/ContentContext";
import { FiLinkedin } from "react-icons/fi";

export default function Founders() {
    const { data } = useContext(ContentContext);
    const f = data.founders;
    if (!f || !f.items) return null;

    return (
        <section className="relative py-20 md:py-28 bg-white overflow-hidden">
            <div className="absolute inset-0 brand-pattern opacity-25 pointer-events-none" />
            <div className="relative max-w-6xl mx-auto px-6 lg:px-8">
                <div className="max-w-2xl mb-12">
                    <div className="inline-flex items-center gap-3 mb-4">
                        <span className="h-px w-10 bg-gold-500" />
                        <span className="text-xs font-bold text-brand-emerald tracking-[0.22em] uppercase">
                            {f.eyebrow}
                        </span>
                    </div>
                    <h2 className="font-serif text-3xl md:text-5xl font-bold text-navy-900 mb-4 leading-tight">
                        {f.title}
                    </h2>
                    <p className="text-lg text-navy-700/85 leading-relaxed">{f.subtitle}</p>
                </div>

                <div className="grid md:grid-cols-2 gap-8">
                    {f.items.map((p, i) => (
                        <article
                            key={i}
                            className="bg-navy-50 border border-navy-100 rounded-2xl p-7 hover:border-gold-300 transition shadow-card"
                        >
                            <div className="flex items-start gap-5 mb-5">
                                <div className="w-20 h-20 rounded-2xl overflow-hidden bg-brand-deep text-white flex items-center justify-center font-serif font-bold text-2xl shrink-0">
                                    {p.image ? (
                                        <img
                                            src={p.image}
                                            alt={p.name}
                                            loading="lazy"
                                            className="w-full h-full object-cover"
                                            onError={(e) => {
                                                e.currentTarget.outerHTML = `<span>${p.name
                                                    .split(" ")
                                                    .map((s) => s[0])
                                                    .slice(0, 2)
                                                    .join("")}</span>`;
                                            }}
                                        />
                                    ) : (
                                        p.name
                                            .split(" ")
                                            .map((s) => s[0])
                                            .slice(0, 2)
                                            .join("")
                                    )}
                                </div>
                                <div>
                                    <h3 className="font-serif text-xl font-bold text-navy-900 leading-tight">
                                        {p.name}
                                    </h3>
                                    <div className="text-xs uppercase tracking-[0.18em] font-semibold text-brand-emerald mt-1">
                                        {p.title}
                                    </div>
                                </div>
                            </div>
                            <p className="text-sm text-navy-700/85 leading-relaxed mb-4">{p.bio}</p>
                            {p.quote && (
                                <blockquote className="border-l-4 border-gold-400 ps-4 italic text-navy-700 mb-5">
                                    "{p.quote}"
                                </blockquote>
                            )}
                            {p.linkedin && (
                                <a
                                    href={p.linkedin}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center gap-2 text-sm font-semibold text-brand-emerald hover:text-brand-deep transition"
                                >
                                    <FiLinkedin className="w-4 h-4" /> LinkedIn
                                </a>
                            )}
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
